import React, { useState, Component } from 'react';
import { motion } from 'framer-motion';
export function CompraVenta() {
  const [formData, setFormData] = useState({
    nombre: '',
    telefono: '',
    auto: '',
    entregaAuto: 'No',
    capital: 'Menos de U$S 3.000',
    cuota: 'Hasta $150.000',
    veraz: 'No sé',
    ingresos: 'Ninguno'
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hola Flash & Go! Me interesa comprar un auto. Mis datos:
*Nombre:* ${formData.nombre}
*Teléfono:* ${formData.telefono}
*Auto de interés:* ${formData.auto}
*Entrega auto:* ${formData.entregaAuto}
*Capital:* ${formData.capital}
*Cuota máxima:* ${formData.cuota}
*Veraz:* ${formData.veraz}
*Ingresos:* ${formData.ingresos}`;
    window.open(`https://wa.me/5491168898054?text=${encodeURIComponent(message)}`, '_blank');
  };
  return <section id="compra-venta" className="py-32 bg-brand-black relative" data-id="element-51">
      <div className="max-w-7xl mx-auto px-6" data-id="element-52">
        <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-53">
          {/* Left Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} data-id="element-54">
            <h2 className="font-heading text-5xl md:text-6xl text-brand-white mb-4" data-id="element-55">
              Encontrá tu <span className="text-brand-gold" data-id="element-56">próximo auto</span>
            </h2>
            <p className="text-xl text-brand-white/80 mb-8" data-id="element-57">
              Amplio stock · Financiación hasta el 100% · Autos usados y 0km
            </p>

            <div className="flex flex-col gap-4 mb-12" data-id="element-58">
              {['✓ SUVs y camionetas', '✓ Sedanes y compactos', '✓ Financiación en cuotas'].map((pill, i) => <div key={i} className="inline-flex items-center px-4 py-2 bg-brand-gold/10 border border-brand-gold/30 text-brand-gold rounded-full w-fit font-medium" data-id="element-59">
                  {pill}
                </div>)}
            </div>

            {/* Form */}
            <div className="bg-[#111] border border-brand-gold/30 p-8 rounded-xl relative overflow-hidden" data-id="element-60">
              <div className="absolute top-0 left-0 w-full h-1 bg-brand-gold" data-id="element-61"></div>
              <h3 className="font-heading text-3xl text-brand-gold mb-6" data-id="element-62">
                Consultá por un auto
              </h3>

              <form onSubmit={handleSubmit} className="space-y-4" data-id="element-63">
                <div className="grid grid-cols-2 gap-4" data-id="element-64">
                  <div data-id="element-65">
                    <label className="block text-sm text-brand-white/70 mb-1" data-id="element-66">
                      Nombre completo
                    </label>
                    <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                    ...formData,
                    nombre: e.target.value
                  })} data-id="element-67" />
                  </div>
                  <div data-id="element-68">
                    <label className="block text-sm text-brand-white/70 mb-1" data-id="element-69">
                      Teléfono
                    </label>
                    <input required type="tel" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                    ...formData,
                    telefono: e.target.value
                  })} data-id="element-70" />
                  </div>
                </div>

                <div data-id="element-71">
                  <label className="block text-sm text-brand-white/70 mb-1" data-id="element-72">
                    Auto de interés (marca y modelo)
                  </label>
                  <input required type="text" className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                  ...formData,
                  auto: e.target.value
                })} data-id="element-73" />
                </div>

                <div data-id="element-74">
                  <label className="block text-sm text-brand-white/70 mb-2" data-id="element-75">
                    ¿Tenés auto para entregar como parte de pago?
                  </label>
                  <div className="flex gap-4" data-id="element-76">
                    {['Sí', 'No'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-77">
                        <input type="radio" name="entrega" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                      ...formData,
                      entregaAuto: e.target.value
                    })} defaultChecked={opt === 'No'} data-id="element-78" />
                        {opt}
                      </label>)}
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-79">
                  <div data-id="element-80">
                    <label className="block text-sm text-brand-white/70 mb-1" data-id="element-81">
                      Capital disponible en USD
                    </label>
                    <select className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                    ...formData,
                    capital: e.target.value
                  })} data-id="element-82">
                      <option data-id="element-83">Menos de U$S 3.000</option>
                      <option data-id="element-84">U$S 3.000 a U$S 6.000</option>
                      <option data-id="element-85">U$S 6.000 a U$S 10.000</option>
                      <option data-id="element-86">Más de U$S 10.000</option>
                      <option data-id="element-87">Sin anticipo, 100% financiado</option>
                    </select>
                  </div>
                  <div data-id="element-88">
                    <label className="block text-sm text-brand-white/70 mb-1" data-id="element-89">
                      Cuota máxima mensual
                    </label>
                    <select className="w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white focus:border-brand-gold outline-none transition-colors" onChange={e => setFormData({
                    ...formData,
                    cuota: e.target.value
                  })} data-id="element-90">
                      <option data-id="element-91">Hasta $150.000</option>
                      <option data-id="element-92">Hasta $300.000</option>
                      <option data-id="element-93">Hasta $500.000</option>
                      <option data-id="element-94">Más de $500.000</option>
                    </select>
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4" data-id="element-95">
                  <div data-id="element-96">
                    <label className="block text-sm text-brand-white/70 mb-2" data-id="element-97">
                      ¿Estás en Veraz?
                    </label>
                    <div className="flex flex-wrap gap-4" data-id="element-98">
                      {['Sí', 'No', 'No sé'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-99">
                          <input type="radio" name="veraz" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                        ...formData,
                        veraz: e.target.value
                      })} defaultChecked={opt === 'No sé'} data-id="element-100" />
                          <span translate="no" className="notranslate" data-id="element-101">
                            {opt}
                          </span>
                        </label>)}
                    </div>
                  </div>
                  <div data-id="element-102">
                    <label className="block text-sm text-brand-white/70 mb-2" data-id="element-103">
                      Ingresos
                    </label>
                    <div className="flex flex-wrap gap-4" data-id="element-104">
                      {['Recibo de sueldo', 'Monotributo', 'Ninguno'].map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white cursor-pointer" data-id="element-105">
                            <input type="radio" name="ingresos" value={opt} className="accent-brand-gold" onChange={e => setFormData({
                        ...formData,
                        ingresos: e.target.value
                      })} defaultChecked={opt === 'Ninguno'} data-id="element-106" />
                            {opt}
                          </label>)}
                    </div>
                  </div>
                </div>

                <button type="submit" className="w-full mt-6 py-4 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-107">
                  ENVIAR CONSULTA
                </button>
              </form>
            </div>
          </motion.div>

          {/* Right Image */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="h-full min-h-[600px] rounded-2xl overflow-hidden relative" data-id="element-108">
            <img src="https://cdn.shopify.com/s/files/1/0740/9788/5319/files/IMG-20260607-WA0003.jpg?v=1780807072" alt="Stock de autos Flash & Go" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-109" />
            <div className="absolute inset-0 bg-gradient-to-t from-brand-black via-transparent to-transparent" data-id="element-110"></div>
          </motion.div>
        </div>
      </div>

      {/* Divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-brand-gold/30 to-transparent" data-id="element-111"></div>
    </section>;
}